import { Tabs as AntTabs, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { t } from 'ttag';

import useTab from '@hooks/useTab';

import Events from './Events';
import Organizations from './Organizations';
import Staff from './Staff';
import Trials from './Trials';

const Title = styled(Typography.Title)`
  margin-left: 45px;
  margin-top: 40px;
  padding-bottom: 40px;
  && {
    font-weight: 400;
  }
`;

const Tabs = styled(AntTabs)`
  .ant-tabs-tabpane {
    padding: 10px 45px;
  }
`;

const TAB_EVENTS = 'events';
const TAB_TRIALS = 'trials';
const TAB_ORGANIZATIONS = 'organizations';
const TAB_STAFF = 'staff';

const TAB_DEFAULT = TAB_EVENTS;
const VALID_TABS = [TAB_EVENTS, TAB_TRIALS, TAB_ORGANIZATIONS, TAB_STAFF];

const ManageMobi = () => {
  const [activeTab, onChange] = useTab(TAB_DEFAULT, VALID_TABS);

  return (
    <>
      <Title>{t`ManageMobi`}</Title>
      <Tabs
        type="card"
        activeKey={activeTab}
        style={{
          // Make sure to leave some space for the action bar at the bottom
          marginBottom: 50,
        }}
        tabBarStyle={{ marginBottom: 0, paddingLeft: 45 }}
        onChange={onChange}
        items={[
          {
            key: TAB_EVENTS,
            label: t`Events`,
            children: <Events />,
          },
          {
            key: TAB_TRIALS,
            label: t`Trials`,
            children: <Trials />,
          },
          {
            key: TAB_ORGANIZATIONS,
            label: t`Organizations`,
            children: <Organizations />,
          },
          // We don't want to show the Staff tab normally to anyone.
          // It should only be visible when the user is accessing the page from a link with `?tab=staff`.
          // This is a "highly secured" tab ¯\_(ツ)_/¯
          activeTab === TAB_STAFF && {
            key: TAB_STAFF,
            label: t`Staff`,
            children: <Staff />,
          },
        ]}
        destroyInactiveTabPane
      />
    </>
  );
};

export default ManageMobi;
